import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import { Skeleton, useTheme } from '@ori-ui/mui';
import { ARTICLE_BOX_SKELETON } from "./constants";
import { Root } from "./styles";
import { ARTICLE_BOX_DESKTOP_WIDTH, ARTICLE_BOX_MOBILE_WIDTH } from "../ArticleBox";

/**
 * Skeleton component for `ArticleBox`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ArticleBoxSkeleton = function ArticleBoxSkeleton(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'pulse' : _ref$animation,
    className = _ref.className;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var isMobile = useIsMobile();
  var _useTheme = useTheme(),
    spacing = _useTheme.spacing;
  return /*#__PURE__*/_jsxs(Root, {
    className: className,
    "data-testid": getTestId(ARTICLE_BOX_SKELETON),
    children: [/*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "170px",
      animation: animation,
      sx: {
        borderRadius: spacing(1),
        marginBottom: spacing(3),
        maxWidth: isMobile ? ARTICLE_BOX_MOBILE_WIDTH : ARTICLE_BOX_DESKTOP_WIDTH
      }
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "50px",
      height: "18px",
      animation: animation,
      sx: {
        marginBottom: spacing(3)
      }
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "64px",
      animation: animation,
      sx: {
        marginBottom: spacing(1)
      }
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: "45px",
      animation: animation,
      sx: {
        marginBottom: spacing(2)
      }
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "64px",
      height: "20px",
      animation: animation
    })]
  });
};
//# sourceMappingURL=ArticleBoxSkeleton.js.map